/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any */
declare let base: any;
import { ModuleBase } from './ModuleBase'

export class ChannelModule extends ModuleBase {
  init(): void {}

  onClear(): void {}

  onLoad(): void {}

  onDestroy(): void {}

  onPreloadData(): void {}

  inits2c(): void {}

  getWithDrawGolds() {
    let goldArr = [200, 500, 1000, 2000, 5000, 10000]
    if (base.channelId == 601) {
      goldArr = [110, 300, 500, 1000, 2000, 5000]
    }
    return goldArr
  }
}
